/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-29 13:38:34
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-26 13:48:02
 * @Description: 活动插件
 * 自定义Vue.prototype:
 * $config    对应活动目录config文件
 * $site      当前网站主目录
 * $apiwxauth @/api/act-wxauth
 * $apidf     @/api/act-logic-dengfan
 * $httpdf    @/http/act-logic-dengfan
 * $wx        @/services/act-wxjssdk
 * $util      @/utils/common
 * $goPage    跳转页面，可直接绑定到事件上
 * $showModal 弹出提示框
 * $showToast 浮动提示框
 * $showLoading 加载提示框
 * $hideLoading 隐藏加载提示框
 */

import "@/assets/styles/act-animate.css";
import "@/assets/styles/act-border.css";
import "@/assets/styles/act-layer.css";
import "@/assets/styles/act-loading.css";
import "@/assets/styles/act-mint-fix.css";
import "@/assets/styles/act-reset.css";
import "@/assets/styles/act-text.css";

import "animate.css";
import "mint-ui/lib/style.css";

import pluginAudio from "./audio";

import apiwxauth from "@/api/act-wxauth";
import apidf from "@/api/act-logic-dengfan";
import httpdf from "@/http/act-logic-dengfan";

import apizt from "@/api/act-logic-zouteng";
import httpzt from "@/http/act-logic-zouteng";

import util from "@/utils/common";
require("@/utils/setrem");
import wx from "@/services/act-wxjssdk";
import { MessageBox, Toast, Indicator } from "mint-ui";

require("@/components/act-components"); //注册代码库通用组件
require(`@/views/${process.env.VUE_APP_PROJECT_DIR}/components/auto-register-components`); //注册当前活动目录的组件。
require(`@/views/${process.env.VUE_APP_PROJECT_DIR}/plugin`); //注册当前活动目录的插件。
require(`@/views/${process.env.VUE_APP_PROJECT_DIR}/app.styl`); //注册当前活动目录的通用样式。

let actPlugin = {
  // toast实例
  toastInstance: null,
};
actPlugin.install = function (Vue) {
  Vue.use(pluginAudio);
  // config
  let config = require(`@/views/${process.env.VUE_APP_PROJECT_DIR}/config`).default;
  Vue.prototype.$config = config;
  // setting
  let setting = require(`@/views/${process.env.VUE_APP_PROJECT_DIR}/setting`).default;
  Vue.prototype.$setting = setting;
  // site
  // Vue.prototype.$site = `${config.env[process.env.VUE_APP_SERVE_ENV].site.protocol}//${
  //   config.env[process.env.VUE_APP_SERVE_ENV].site.appid
  //   }.${config.env[process.env.VUE_APP_SERVE_ENV].site.domain
  //   }${process.env.BASE_URL}${process.env.VUE_APP_PROJECT_DIR}.html`;
  Vue.prototype.$site = `${location.protocol}//${location.host}${location.pathname}`;
  // api
  // apiwxauth.appid = config.env[process.env.VUE_APP_SERVE_ENV].apiActWxauth.appid;
  // apiwxauth.protocol = config.env[process.env.VUE_APP_SERVE_ENV].apiActWxauth.protocol;
  // apiwxauth.domain = config.env[process.env.VUE_APP_SERVE_ENV].apiActWxauth.domain;

  let host = window.location.host;
  let appid = host.substring(0, host.indexOf("."));
  // let domain=host.substring(host.indexOf('.')+1)

  if (appid == "" || host.indexOf("localhost") >= 0) {
    apiwxauth.appid = "wx01f0b018d4951434";
  } else {
    // 授权接口请求
    let index=appid.indexOf("-")
    apiwxauth.appid = index==-1?appid:appid.substring(0,index);
    // old-act
    // apiwxauth.protocol = window.location.protocol
    // apiwxauth.domain = domain
  }
  apiwxauth.protocol = "https:";
  let domain = process.env.VUE_APP_BASEAPI.replace("https://", "");
  domain = domain.replace("/", "");
  apiwxauth.domain = domain;
  Vue.prototype.$appId = apiwxauth.appid;

  // 其他接口请求的域名
  Vue.prototype.$apiwxauth = apiwxauth;
  // apipt.protocol = config.env[process.env.VUE_APP_SERVE_ENV].apiActLogicPlatform.protocol;
  // apipt.domain = config.env[process.env.VUE_APP_SERVE_ENV].apiActLogicPlatform.domain;
  // Vue.prototype.$apipt = apipt;

  // httpdf 请求域名
  apidf.protocol = config.env[process.env.VUE_APP_SERVE_ENV].apiActLogicDengfan.protocol;
  apidf.domain = config.env[process.env.VUE_APP_SERVE_ENV].apiActLogicDengfan.domain;
  Vue.prototype.$apidf = apidf;
  apizt.protocol = config.env[process.env.VUE_APP_SERVE_ENV].apiActLogicZouTeng.protocol;
  apizt.domain = config.env[process.env.VUE_APP_SERVE_ENV].apiActLogicZouTeng.domain;
  Vue.prototype.$apizt = apizt;

  // 销售线索请求的域名
  // if (config.env[process.env.VUE_APP_SERVE_ENV].YQCloudAPI && config.env[process.env.VUE_APP_SERVE_ENV].servicesRushiH5jssdk) {
  //   apirsh5.protocol = config.env[process.env.VUE_APP_SERVE_ENV].YQCloudAPI.protocol;
  //   apirsh5.domain = config.env[process.env.VUE_APP_SERVE_ENV].YQCloudAPI.domain;
  //   Vue.prototype.$apirsh5 = apirsh5;
  // }

  // http
  Object.assign(httpdf.options, config.env[process.env.VUE_APP_SERVE_ENV].httpActLogicDengfan);
  Vue.prototype.$httpdf = httpdf;
  Object.assign(httpzt.options, config.env[process.env.VUE_APP_SERVE_ENV].httpActLogicZouTeng);
  Vue.prototype.$httpzt = httpzt;

  // if (config.env[process.env.VUE_APP_SERVE_ENV].YQCloudAPI && config.env[process.env.VUE_APP_SERVE_ENV].servicesRushiH5jssdk) {
  //   Vue.prototype.$httprsh5 = httprsh5;
  // }

  // services
  Vue.prototype.$wx = wx;
  // if (config.env[process.env.VUE_APP_SERVE_ENV].YQCloudAPI && config.env[process.env.VUE_APP_SERVE_ENV].servicesRushiH5jssdk) {
  //   Object.assign(rsh5.options, config.env[process.env.VUE_APP_SERVE_ENV].servicesRushiH5jssdk);
  //   Vue.prototype.$rsh5 = rsh5;
  // }

  // utils
  Vue.prototype.$util = util;

  /**
   * 跳转页面
   */
  Vue.prototype.$goPage = function (name, params) {
    this.$router.push({ name, query: params });
  };
  Vue.prototype.$goBack = function (name, params) {
    this.$router.go(-1);
  };
  /**
   * 拨打电话
   */
  Vue.prototype.$makePhoneCall = function (phone) {
    location.href = `tel:${phone}`;
  };

  /**
   * http://mint-ui.github.io/docs/#/zh-cn2/message-box
   * 参数	说明	类型	可选值	默认值
   title	提示框的标题	String
   message	提示框的内容	String
   showConfirmButton	是否显示确认按钮	Boolean		true
   showCancelButton	是否显示取消按钮	Boolean		false
   confirmButtonText	确认按钮的文本	String
   confirmButtonHighlight	是否将确认按钮的文本加粗显示	Boolean		false
   confirmButtonClass	确认按钮的类名	String
   cancelButtonText	取消按钮的文本	String
   cancelButtonHighlight	是否将取消按钮的文本加粗显示	Boolean		false
   cancelButtonClass	取消按钮的类名	String
   closeOnClickModal	是否在点击遮罩时关闭提示光	Boolean	true (alert 为 false)
   showInput	是否显示一个输入框	Boolean		false
   inputType	输入框的类型	String		'text'
   inputValue	输入框的值	String
   inputPlaceholder	输入框的占位符	String
   */
  Vue.prototype.$showModal = function (object) {
    return new Promise((resolve) => {
      if (typeof object == "object") {
        MessageBox(object).then((res) => {
          if (res == "confirm") {
            resolve();
          }
        });
      } else {
        MessageBox.alert(object).then(() => {
          resolve();
        });
      }
    });
  };
  /**
   * http://mint-ui.github.io/docs/#/zh-cn2/toast
   * 参数	说明	类型	可选值	默认值
   message	文本内容	String
   position	Toast 的位置	String	'top'
   'bottom'
   'middle'	'middle'
   duration	持续时间（毫秒），若为 -1 则不会自动关闭	Number		3000
   className	Toast 的类名。可以为其添加样式	String
   iconClass	icon 图标的类名	String
   */
  Vue.prototype.$showToast = function (object) {
    return new Promise((resolve) => {
      let duration = 3000;
      if (typeof object == "object") {
        this.toastInstance = Toast(object);
        if (object.duration) {
          duration = object.duration;
        }
      } else {
        duration = 2000;
        this.toastInstance = Toast({ message: object, duration: duration });
      }
      setTimeout(() => {
        resolve();
      }, duration);
    });
  };
  Vue.prototype.$hideToast = function () {
    if (this.toastInstance) this.toastInstance.close();
  };
  /**
   * http://mint-ui.github.io/docs/#/zh-cn2/indicator
   * 参数	说明	类型	可选值	默认值
   text	文本内容	String
   spinnerType	加载图标的类型	String	'snake'
   'fading-circle'
   'double-bounce'
   'triple-bounce'	'snake'
   */
  Vue.prototype.$showLoading = function (object) {
    Indicator.open(object);
  };
  Vue.prototype.$hideLoading = function () {
    Indicator.close();
  };
};
export default actPlugin;
